import { render, staticRenderFns } from "./CustomDetailContent.vue?vue&type=template&id=538118df&scoped=true"
import script from "./CustomDetailContent.vue?vue&type=script&lang=js"
export * from "./CustomDetailContent.vue?vue&type=script&lang=js"
import style0 from "./CustomDetailContent.vue?vue&type=style&index=0&id=538118df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538118df",
  null
  
)

export default component.exports